import type { CustomersRFMPayload } from './types';

/** v2.34 — RFM segmentation list. Throws on HTTP errors so the page can
 * show its usual error/retry treatment (503 = daemon down). */
export async function fetchCustomersRFM(days = 365, sid?: number | null): Promise<CustomersRFMPayload> {
  const params = new URLSearchParams({ days: String(days) });
  if (sid) params.set('sid', String(sid));
  const res = await fetch(`/api/customers-rfm?${params}`, { credentials: 'same-origin' });
  if (!res.ok) {
    throw new Error(res.status === 502 || res.status === 503
      ? '503: daemon offline'
      : `customers-rfm failed: ${res.status}`);
  }
  return (await res.json()) as CustomersRFMPayload;
}
